import React from "react";
import connect from "react-redux/es/connect/connect";
import isEqual from "lodash-es/isEqual";
import Source from "./Source";

export class TillBasedSource extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        const {props} = {...this.props};
        if (!isEqual(prevProps.till, this.props.till) || !isEqual((props.getValue("source") || {}).id, (((this.props.till|| {}).pos || {}).location || {}).id)) {
            props.setFieldValue && props.setFieldValue("source", ((this.props.till|| {}).pos || {}).location || null);
        }
    }

    getProps = (name) => {
        const {props} = {...this.props};
        const fieldProps = props.getProps(name);
        fieldProps.disabled = true;
        return fieldProps;
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels, pool, operationitems} = props;
        return (hidden || []).indexOf("source") === -1 && <Source
            {...{...propsTop, props: {...propsTop.props, getProps: this.getProps}}} visible={this.props.visible} />;
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(TillBasedSource);